import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`List of Animations`}</h2>
    <p>{`There is no substitute for watching animations when it comes to understanding geodynamics. The principles employed in making the Gondwana model are illustrated in the following series of animations. `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../feb04"
        }}>{`A. The CPSL 'Atlas' feb04 model`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../grav.marg"
        }}>{`B. Which continental outlines to fit?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../starting-data"
        }}>{`C. Global Data-sets`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../mar-mag-anom"
        }}>{`D. Marine Magnetic Anomalies`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../euler-poles"
        }}>{`E. Understanding Euler Poles`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../making-ends-meet"
        }}>{`F. Making Ends Meet`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../oceansonlygrow"
        }}>{`G. Oceans Only Grow`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../mid-ocean-ridges"
        }}>{`H. Mid-Ocean Ridges`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../large-igneous-provinces"
        }}>{`I. Large Igneous Provinces`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../fixed-is-fixed"
        }}>{`J. A fixed mantle reference frame`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../africa-antarctica"
        }}>{`K. The Africa-Antarctica corridor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../AAC-detail"
        }}>{`K-1. The AAC in the Jurassic and Early Cretaceous`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../moz-plains"
        }}>{`L. Mozambique Plains & Ridge`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../aac-anim-1"
        }}>{`M. The Bouvet triple junction`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../shun"
        }}>{`N. Smaller fragments evade the Bouvet plume`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../agulhas-plat"
        }}>{`O. The Agulhas Plateau`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../ego-aac-plates"
        }}>{`P. East Gondwana Break-up`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../swir-3"
        }}>{`Q. Southwest Indian Ridge`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../sri-lanka-2"
        }}>{`R. India - Sri Lanka - Antarctica`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../east-versus-west"
        }}>{`S. STASS animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../articulated-africa"
        }}>{`T. Articulated Africa`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../guinea-1"
        }}>{`U. Gulf of Guinea - Borborema - African Rifts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../Africa-fabric"
        }}>{`V. The geological history of southern Africa`}</a></li>
    </ul>
    <p>{`The building of animations that are credible mechanically, geometrically and geologically is a challenge that tests the ideas behind the animations rather severely. Many ideas, including those that get published, turn out to be untenable when subjected to simple constraints of geometry and time. The animations listed above attempt to show the lessons learned and the principles established over many years of working with the Gondwana dispersal system using the Cambridge Paleomap Services Limited (CPSL) `}<em parentName="p">{`Atlas`}</em>{` paleo-reconstruction software. In addition to modelling continental movements, the positions of the mid-ocean ridge systems have been modelled and checked against the dispersal record they have left in the topography of the ocean floor created over the past 200 million years, as shown in the animation on the `}<strong parentName="p">{`Gondwana`}</strong>{` main page.`}</p>
    <p><em parentName="p">{`Last update: 2026 September 24.`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      